import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}} \\ast \\text{\\textit{100}}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>
      Die Arbeitskostenquote drückt das Verhältnis der Bruttolöhne inkl. Sozialleistungen und übrigen Personalkosten in % zu den
      Bruttolöhnen zuzüglich der Gemeinkosten in % mal den Faktor 100 aus.
    </p>
    <BlockMath>
      {getLatexString("(Bruttolohn zzgl. Sozialleistungen und übrige Personalkosten in \\%)", "Bruttolohn zuzüglich der Gemeinkosten in \\%")}
    </BlockMath>
  </div>
);

const fr = (
  <div>
    <p>
      Le taux de coûts de la main d’œuvre exprime le rapport entre les salaires bruts, prestations sociales et
      autres frais de personnel (en %) compris, et les salaires bruts majorés des frais généraux (en %), multiplié par le facteur 100.
    </p>
    <BlockMath>
      {getLatexString("(Salaire brut plus prestations sociales et autres frais de personnel en \\%)", "Salaire brut plus frais généraux en \\%")}
    </BlockMath>
  </div>
);

const it = (
  <div>
    <p>
      La quota dei costi del lavoro esprime il rapporto tra i salari lordi, comprese le prestazioni sociali e gli altri
      costi del personale, in % rispetto ai salari lordi più le spese generali in % moltiplicate per il fattore 100.
    </p>
    <BlockMath>
      {getLatexString("(Salario lordo più prestazioni sociali e altri costi del personale in \\%)", "Salario lordo più spese generali in \\%")}
    </BlockMath>
  </div>
);

const en = (
  <div>
    <p>
      Labour-cost ratio expresses the ratio of gross salaries including social benefits and other personnel costs in % relative to
      gross salaries plus overheads in %, multiplied by a factor of 100.
    </p>
    <BlockMath>
      {getLatexString("(Gross salary plus social benefits and other personnel costs in \\%)", "Gross salary plus overhead costs in \\%")}
    </BlockMath>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
